export const getBillingTerms = (planSpecificBillingTerms, offerFlow) => {
    const firstSentence = offerFlow === 'exemptions' ? 'Your payment method will be used for automatic payment of all invoices.' : 'Your payment method will be used for automatic payment of all invoices related to any Avalara products or services you have purchased.';
    return [firstSentence,
        "You're authorizing us to process payment using your payment method. We will automatically charge your payment method on the invoice due date. You can update your payment method at any time.",
        ...planSpecificBillingTerms];
};
